import { createSlice } from "@reduxjs/toolkit";
import { Survey, Meta } from "src/store/types";
import { doDeleteSurvey, doFetchSurveyList } from "./survey.action";

interface SurveyState {
  list: Survey[];
  meta: Meta | null;
  loading: boolean;
  error: string | null;
  searchQuery: string;
}

const initialState: SurveyState = {
  list: [],
  meta: null,
  loading: false,
  error: null,
  searchQuery: "",
};

export const surveySlice = createSlice({
  name: "survey",
  initialState,
  reducers: {
    setSurveySearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    clearSurveySearch: (state) => {
      state.searchQuery = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(doFetchSurveyList.pending, (state) => {
        state.loading = true;
      })
      .addCase(doFetchSurveyList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(doFetchSurveyList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(doDeleteSurvey.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doDeleteSurvey.fulfilled, (state, action) => {
        state.loading = false;

        const deletedId = action.meta.arg;

        state.list = state.list.filter(
          (item) => String(item.id) !== String(deletedId)
        );
      })
      .addCase(doDeleteSurvey.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setSurveySearchQuery, clearSurveySearch } = surveySlice.actions;

export default surveySlice.reducer;
